import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plane, Mail, Lock } from "lucide-react";
import Seo from "../components/Seo";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login({ email, password });
      toast({ title: "Welcome back!", description: "You are now signed in." });
      navigate("/");
    } catch (err) {
      toast({ title: "Login failed", description: err?.response?.data?.detail || "Invalid credentials", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-[80vh] items-center justify-center bg-slate-50 px-5 py-12">
      <Seo title="Login | FindMyFlight" description="Sign in to your FindMyFlight account." path="/login" />
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-600 text-white"><Plane className="h-5 w-5" /></span>
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Welcome back</h1>
          <p className="mt-1 text-sm text-slate-500">Sign in to manage your alerts and searches.</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Email</label>
            <div className="flex h-11 items-center gap-2 rounded-lg border border-slate-200 px-3 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100">
              <Mail className="h-4 w-4 text-slate-400" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="w-full bg-transparent text-sm outline-none" />
            </div>
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Password</label>
            <div className="flex h-11 items-center gap-2 rounded-lg border border-slate-200 px-3 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100">
              <Lock className="h-4 w-4 text-slate-400" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full bg-transparent text-sm outline-none" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-blue-600 font-semibold hover:bg-blue-700">{loading ? "Signing in..." : "Sign in"}</Button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-500">Don’t have an account? <Link to="/register" className="font-semibold text-blue-600 hover:underline">Sign up</Link></p>
      </div>
    </main>
  );
}
